import { render, staticRenderFns } from "./affiche.vue?vue&type=template&id=48f12ce1&scoped=true&"
import script from "./affiche.vue?vue&type=script&lang=js&"
export * from "./affiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f12ce1",
  null
  
)

export default component.exports